import { getPlayerMapRating } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { getMyMapRatingInputSchema } from "#/lib/serverInputSchemas";
import { resolveRequestGameContext } from "#/server/game/requestGameContext.server";

export const getMyMapRating = createServerFn({ method: "GET" })
  .validator(getMyMapRatingInputSchema)
  .handler(async ({ data }): Promise<{ rating: number | null }> => {
    setRouteAction("get_map_rating");
    const { playerId, isAnonymous } = await resolveRequestGameContext();
    if (isAnonymous) {
      return { rating: null };
    }
    const rating = await getPlayerMapRating({ mapId: data.mapId, playerId });
    return { rating };
  });
